import { SVGProps, Ref, forwardRef } from 'react';

export const TreeFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M15.985 21.3c-.03 1.055-.139 1.682-.57 2.114l-.115.104C14.707 24 13.767 24 12 24l-1.246-.009c-.997-.025-1.619-.12-2.054-.473l-.114-.104c-.432-.432-.54-1.059-.57-2.114z"
            fill="currentColor"
        />
        <path
            d="M12.267.013c1.299.125 2.155 1.186 3.764 3.183l1.636 2.033c1.14 1.415 1.708 2.123 1.06 2.625-.295.23-.766.354-1.47.421l2.03 2.18c1.463 1.57 2.196 2.356 1.364 2.915-.35.234-.887.368-1.672.447l1.927 1.862c1.789 1.728 2.684 2.592 1.667 3.207l-.183.097c-.977.46-2.911.511-6.398.517H8.008c-3.486-.006-5.42-.058-6.397-.517l-.183-.097c-.89-.538-.317-1.267 1.04-2.599l.627-.608 1.926-1.862c-.785-.079-1.321-.213-1.67-.447-.729-.489-.26-1.151.85-2.362l.513-.554 2.03-2.178c-.705-.067-1.175-.192-1.471-.422-.567-.44-.202-1.037.66-2.126l.4-.499 1.638-2.033C9.687 1.066 10.545 0 12 0z"
            fill="currentColor"
        />
    </svg>
));
TreeFilledSize24Glyph.displayName = 'TreeFilledSize24Glyph';
